import { render, staticRenderFns } from "./OLabel.vue?vue&type=template&id=67b9df62&scoped=true"
import script from "./OLabel.vue?vue&type=script&lang=js"
export * from "./OLabel.vue?vue&type=script&lang=js"
import style0 from "./OLabel.vue?vue&type=style&index=0&id=67b9df62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b9df62",
  null
  
)

export default component.exports